import { Plus } from "lucide-react";
import { Button } from "../ui/button";
import { useState } from "react";
import { BatchImportMenu } from "@/components/batch-import/BatchImportMenu";
import type { BatchImportType } from "@/components/batch-import/batchImportConfig";

type NewItemDialogTriggerProps = {
  title: string;
  Dialog: (props: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  }) => JSX.Element;
  /**
   * Si fourni, le bouton devient un split-button : clic = modale de création
   * classique, chevron = import batch d'images pour ce type de fiche.
   */
  batchImportType?: BatchImportType;
};

const NewItemDialogTrigger = ({
  title,
  Dialog,
  batchImportType,
}: NewItemDialogTriggerProps) => {
  const [newItemDialogOpen, setNewItemDialogOpen] = useState(false);

  return (
    <>
      {batchImportType ? (
        <div className="flex items-stretch">
          <Button
            type="button"
            className="flex items-center gap-2 rounded-r-none"
            onClick={() => setNewItemDialogOpen(true)}
          >
            <Plus size={16} />
            {title}
          </Button>
          <BatchImportMenu
            type={batchImportType}
            triggerClassName="rounded-l-none border-l border-white/25"
          />
        </div>
      ) : (
        <Button
          type="button"
          className="flex items-center gap-2"
          onClick={() => setNewItemDialogOpen(true)}
        >
          <Plus size={16} />
          {title}
        </Button>
      )}

      <Dialog open={newItemDialogOpen} onOpenChange={setNewItemDialogOpen} />
    </>
  );
};

export default NewItemDialogTrigger;
